module.exports = __webpack_public_path__ + "img/html.220c351e.svg";